import React from 'react';

export default ({ content }) => (
    <ol className="ordered-list">
        {content.map((item, index) => {
            return (
                <li key={index} className="ordered-list__item">
                    {item}
                </li>
            );
        })}
    </ol>
);



// WEBPACK FOOTER //
// ./src/components/ui/ordered-list.js